export default {"src":"/_next/static/media/fifteen-lb.d4157bb8.svg","height":45,"width":86,"blurWidth":0,"blurHeight":0};